import cloneDeep from "lodash/cloneDeep";
import {
  REQUEST_DOWNLOAD_SAVED_REPORT,
  RESPONSE_DOWNLOAD_SAVED_REPORT,
  REQUEST_DOWNLOAD_SAVED_REPORT_FAILURE,
  CLEAR_DOWNLOAD_SAVED_REPORT,
} from "../actions/downloadSavedReportActions";

import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
};

const downloadSavedReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_DOWNLOAD_SAVED_REPORT: {
      return Object.assign({}, state, {
        dataState: states.REQUEST,
      });
    }
    case RESPONSE_DOWNLOAD_SAVED_REPORT: {
      return Object.assign({}, state, {
        dataState: states.READY,
      });
    }
    case REQUEST_DOWNLOAD_SAVED_REPORT_FAILURE: {
      return Object.assign({}, state, {
        dataState: states.FAILURE,
      });
    }
    case CLEAR_DOWNLOAD_SAVED_REPORT: {
      const { id, format } = action.payload;
      let nextState = cloneDeep(state);
      let report = nextState.data.find((item) => item.id === id && item.format === format);
      report.dataState = states.NOT_REQUESTED;

      return Object.assign({}, state, nextState);
    }
    default:
      return state;
  }
};

export default downloadSavedReportReducer;
